import { LoginForm } from "@/components/login-form"
import { Helmet } from "react-helmet-async"

export default function LoginPage() {
  return (
    <>
      <Helmet>
        <title>Login to Fusegu | Access Your Security Dashboard</title>
        <meta 
          name="description" 
          content="Sign in to view your security scans, vulnerability reports, and manage your protected websites. Access your Fusegu account." 
        />
        <meta property="og:title" content="Login to Fusegu Security Platform" />
        <meta property="og:description" content="Sign in to access your security dashboard and vulnerability reports." />
        <meta property="og:url" content="https://fusegusecurity.com/login" />
      </Helmet>
      <div className="flex min-h-svh w-full items-center justify-center p-6 md:p-10">
        <div className="w-full max-w-sm">
          <h1 className="sr-only">Login to Fusegu Security Platform</h1>
          <LoginForm />
        </div>
      </div>
    </>
  )
}